export default __webpack_public_path__ + "static/media/bg_blue.8247b9e1.svg";